import Vue from 'vue'
import Router from 'vue-router'
import request from './utils/ajax.js'
import util from './utils/util'

let routes = [
    { //公共首页
        path: '/',
        component : resolve => require(['./views/home/home.vue'], resolve),
        meta: { title: '多盟轻推送-开发者后台' },
        name: 'index',
        redirect: '/app/list', 
        children: [
            {
                path: '/app',
                meta: { title: '应用列表' },
                name: 'app',
                component: resolve => require(['./views/ssp/app/index'], resolve),
                children: [
                    {
                        path: 'list',
                        name: 'app_list',
                        component: resolve => require(['./views/ssp/app/list'], resolve),
                        meta: { title: '应用列表', keepAlive: true,}
                    },
                ],
            },
            {
                path: '/ad',
                meta: { title: '广告位列表' },
                name: 'ad',
                component: resolve => require(['./views/ssp/position/index'], resolve),
                children: [
                    {
                        path: 'list',
                        name: 'ad_list',
                        component: resolve => require(['./views/ssp/position/list'], resolve),
                        meta: { title: '广告位列表', keepAlive: true,}
                    },
                    {
                        path: 'addAD',
                        name: 'addAD',
                        component: resolve => require(['./views/ssp/position/advertUpdate'], resolve),
                        meta: { title: '添加广告位' }
                    },
                ],
            },
            {
                path: '/stats',
                meta: { title: '数据报表' },
                name: 'stats',
                component: resolve => require(['./views/ssp/stats/index'], resolve),
                children: [
                    {
                        path: 'info',
                        name: 'stats_info',
                        component: resolve => require(['./views/ssp/stats/statInfo'], resolve),
                        meta: { title: '数据报表' }
                    } 
                ]
            },
            {
                path: '/reconciliation',
                meta: { title: '对账' },
                name: 'reconciliation',
                component: resolve => require(['./views/ssp/reconciliation/index.vue'], resolve),
                children: [
                    {
                        path: 'info',
                        name: 'reconcile_info',
                        component: resolve => require(['./views/ssp/reconciliation/info.vue'], resolve),
                        meta: { title: '对账' }
                    } 
                ]
            },
            {
                path: '/doc',
                meta: { title: 'api对接' },
                name: 'apiDocking',
                component: resolve => require(['./views/ssp/doc/index'], resolve),
                children: [
                    {
                        path: 'api',
                        name: 'api',
                        component: resolve => require(['./views/ssp/doc/apiDocking'], resolve),
                        meta: { title: 'api对接' }
                    }
                ],
            },
            {
                path: '/doc',
                meta: { title: 'sdk对接' },
                name: 'sdkDocking',
                component: resolve => require(['./views/ssp/doc/index'], resolve),
                children: [
                    {
                        path: 'sdkWord',
                        name: 'sdkWord',
                        component: resolve => require(['./views/ssp/doc/sdkDocking'], resolve),
                        meta: { title: 'sdk对接文档' },
                    },
                    {
                        path: 'sdkTest',
                        name: 'sdkTest',
                        component: resolve => require(['./views/ssp/doc/sdkTest'], resolve),
                        meta: { title: 'sdk对接文档' },
                    }
                ],
            }
            
        ]
    },
    {
        path: '/login',
        name: 'login',
        component: resolve => require(['./views/user/login'], resolve),
        // 旧登录页面，保留用于兼容
    },
    {
        path: '/login-domestic',
        name: 'login-domestic',
        component: resolve => require(['./views/user/login-domestic'], resolve),
        meta: { title: '登录 - 国内账户' }
    },
    {
        path: '/login-overseas',
        name: 'login-overseas',
        component: resolve => require(['./views/user/login-overseas'], resolve),
        meta: { title: 'Login - Overseas Account' }
    },
    {
        path: '/signup',
        name: 'signup',
        component: resolve => require(['./views/user/signup'], resolve),
    },
    {
        path: '/signup-overseas',
        name: 'signup-overseas',
        component: resolve => require(['./views/user/signup-overseas'], resolve),
    },
    {
        path: '/reset',
        name: 'reset',
        component: resolve => require(['./views/user/reset'], resolve),
    },
    {
        path: '/500',
        name: 'error_500',
        component: resolve => require(['./views/error/500.vue'], resolve),
    },
    {
        path: '/401',
        name: 'error_401',
        component: resolve => require(['./views/error/401.vue'], resolve),
    },
    {
        path: '/403',
        name: 'error_403',
        component: resolve => require(['./views/error/403.vue'], resolve),
    },
    {
        path: '/404',
        name: 'error_404',
        component: resolve => require(['./views/error/404.vue'], resolve),
    },


    //海外路由
    { 
        path: '/abroad',
        component : resolve => require(['./views/abroad/home/home.vue'], resolve),
        meta: { title: '多盟开发者后台' },
        name: 'abroad',
        redirect: '/abroad/app/list', 
        children: [
            {
                path: 'app',
                meta: { title: '应用列表' },
                name: 'abroad-app',
                component: resolve => require(['./views/abroad/ssp/app/index.vue'], resolve),
                children: [
                    {
                        path: 'list',
                        name: 'app_list',
                        component: resolve => require(['./views/abroad/ssp/app/list'], resolve),
                        meta: { title: '应用列表', keepAlive: true,}
                    },
                ],
            },
            {
                path: 'ad',
                meta: { title: '广告位列表' },
                name: 'abroad-ad',
                component: resolve => require(['./views/abroad/ssp/position/index'], resolve),
                children: [
                    {
                        path: 'list',
                        name: 'ad_list',
                        component: resolve => require(['./views/abroad/ssp/position/list'], resolve),
                        meta: { title: '广告位列表', keepAlive: true,}
                    },
                    {
                        path: 'addAD',
                        name: 'addAD',
                        component: resolve => require(['./views/abroad/ssp/position/advertUpdate'], resolve),
                        meta: { title: '添加广告位' }
                    },
                ],
            },
            {
                path: 'block',
                meta: { title: '屏蔽管理' },
                name: 'abroad-block',
                component: resolve => require(['./views/abroad/ssp/block/index'], resolve),
                children: [
                    {
                        path: 'list',
                        name: 'block_list',
                        component: resolve => require(['./views/abroad/ssp/block/list'], resolve),
                        meta: { title: '屏蔽管理'}
                    },
                ],
            },
            {
                path: 'stats',
                meta: { title: '数据报表' },
                name: 'abroad-stats',
                component: resolve => require(['./views/abroad/ssp/stats/index'], resolve),
                children: [
                    {
                        path: 'info',
                        name: 'stats_info',
                        component: resolve => require(['./views/abroad/ssp/stats/statInfo'], resolve),
                        meta: { title: '数据报表' }
                    } 
                ]
            },
            {
                path: 'doc',
                meta: { title: 'sdk对接' },
                name: 'abroad-sdkDocking',
                component: resolve => require(['./views/abroad/ssp/doc/index'], resolve),
                children: [
                    {
                        path: 'sdkWord',
                        name: 'sdkWord',
                        component: resolve => require(['./views/abroad/ssp/doc/sdkDocking'], resolve),
                        meta: { title: 'sdk对接文档' },
                    },
                    {
                        path: 'sdkTest',
                        name: 'sdkTest',
                        component: resolve => require(['./views/abroad/ssp/doc/sdkTest'], resolve),
                        meta: { title: 'sdk对接文档' },
                    },
                    {
                        path: 'appadsTxt',
                        name: 'appadsTxt',
                        component: resolve => require(['./views/abroad/ssp/doc/appadsTxt'], resolve),
                        meta: { title: 'sdk对接文档' },
                    }
                ],
            }, 
            {
                path: 'account',
                meta: { title: '账户' },
                name: 'abroad-account',
                component: resolve => require(['./views/abroad/ssp/account/index.vue'], resolve),
                redirect:"/abroad/account/companyInfo",
                children: [
                    {
                        path: 'companyInfo',
                        name: 'abroad-account-companyInfo',
                        component: resolve => require(['./views/abroad/ssp/account/companyInfo'], resolve),
                        meta: { title: '企业信息'}
                    },
                    /* {
                        path: 'paymentInfo',
                        name: 'abroad-account-paymentInfo',
                        component: resolve => require(['./views/abroad/ssp/account/paymentInfo'], resolve),
                        meta: { title: '结算'}
                    } */
                ],
            }
        ]
    },
]

Vue.use(Router)


let router = new Router({
    mode: 'hash',
    base: '/',
    routes: routes
})

router.beforeEach((to, from, next) => {
    // next();
    // return
    // 如果是从adx过来的，并且携带token
    if(to.path == '/app/list' && to.query.token) {
        let params = {
            token: to.query.token
        }
        request.postData("getUserInfo", params, res => {
            // 验证通过
                if(res.token) {
                    util.setCookie("token", res.token, 7)
                    util.setCookie("user", JSON.stringify(res), 7)
                    // 判断area是2跳转到海外，1跳转到国内
                    if(res.area == 2) {
                        next('/abroad/app/list')
                    } else if(res.area == 1) {
                        next('/app/list')
                    }
                } else {
                    next('/login')
                }
            // 将token存到cookie中
        })
    } else { //多盟开发者后台自行登录
        // 如果用户访问的登录页和注册页，直接放行
        let paths = ['/login', '/signup','/signup-overseas', '/500', '/401', '/403', '/404']
        if (util.inArray(to.path, paths)) {
            next()
        } else {
            // 从cookie中获取保存的token值
            let token = util.getCookie("token")
            // 没有token，强制跳转到登录页
            if (!token) {
                return next('/login')
            } else {
                next()
            }
        }
    }
});

export default router


